import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import { DOMESTIC_STATES, INTERNATIONAL } from "@/data/site";

const IMG = {
  "Himachal Pradesh": "https://images.pexels.com/photos/2440079/pexels-photo-2440079.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Uttarakhand": "https://images.pexels.com/photos/30654780/pexels-photo-30654780.jpeg?auto=compress&cs=tinysrgb&w=900",
  "Uttar Pradesh": "https://images.unsplash.com/photo-1564507592333-c60657eea523?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Jammu & Kashmir": "https://images.unsplash.com/photo-1595815771614-ade9d652a65d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Rajasthan": "https://images.unsplash.com/photo-1477587458883-47145ed94245?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Goa": "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Gujarat": "https://images.unsplash.com/photo-1609766418204-94aae0ecfdfc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Kerala": "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Tamil Nadu": "https://images.unsplash.com/photo-1582510003544-4d00b7f74220?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Karnataka": "https://images.unsplash.com/photo-1567157577867-05ccb1388e66?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Sikkim": "https://images.unsplash.com/photo-1597074866923-dc0589150358?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Assam": "https://images.unsplash.com/photo-1605649487212-47bdab064df7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Meghalaya": "https://images.unsplash.com/photo-1558431382-27e303142255?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Azerbaijan": "https://images.unsplash.com/photo-1601074231509-dce351c05199?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Turkey": "https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Vietnam": "https://images.unsplash.com/photo-1528127269322-539801943592?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Singapore": "https://images.unsplash.com/photo-1525625293386-3f8f99389edd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Nepal": "https://images.unsplash.com/photo-1544735716-392fe2489ffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Thailand": "https://images.unsplash.com/photo-1528181304800-259b08848526?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Bhutan": "https://images.unsplash.com/photo-1553856622-d1b352e9a211?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Malaysia": "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Maldives": "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Mauritius": "https://images.unsplash.com/photo-1544644181-1484b3fdfc62?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Sri Lanka": "https://images.unsplash.com/photo-1566296314736-6eaac1ca0cb9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  "Europe": "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

const FALLBACK = "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900";

function Grid({ items, testid }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid={testid}>
      {items.map((name, i) => (
        <motion.div
          key={name}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.6, delay: (i % 4) * 0.06, ease: [0.25, 1, 0.5, 1] }}
        >
          <Link
            to={`/packages?q=${encodeURIComponent(name)}`}
            data-testid={`destination-${name.toLowerCase().replace(/\s+/g, "-")}`}
            className="group relative block overflow-hidden rounded-2xl aspect-[3/4]"
          >
            <img
              src={IMG[name] || FALLBACK}
              alt={name}
              loading="lazy"
              onError={(e) => { e.currentTarget.src = FALLBACK; }}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/85 via-brand-navy/10 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-5 flex items-end justify-between">
              <span className="font-heading text-xl text-white leading-tight">{name}</span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/20 backdrop-blur text-white transition-colors group-hover:bg-brand-orange">
                <ArrowUpRight size={18} weight="bold" />
              </span>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
}

export default function Destinations() {
  return (
    <div className="pt-14 pb-24">
      <section className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <p className="font-accent text-xs font-bold uppercase tracking-[0.25em] text-brand-orange mb-4">Where to next?</p>
          <h1 className="text-5xl sm:text-6xl font-heading font-medium text-brand-navy leading-tight">Our Destinations</h1>
          <p className="mt-4 max-w-xl text-[#6b6a8a] font-body">From the Himalayas to hidden islands — pick a place and we’ll do the rest.</p>
        </Reveal>

        <div className="mt-14">
          <h2 className="text-3xl font-heading font-medium text-brand-navy mb-7 flex items-center gap-3">India <span className="h-px flex-1 bg-brand-sand" /></h2>
          <Grid items={DOMESTIC_STATES} testid="domestic-grid" />
        </div>

        <div className="mt-20">
          <h2 className="text-3xl font-heading font-medium text-brand-navy mb-7 flex items-center gap-3">International <span className="h-px flex-1 bg-brand-sand" /></h2>
          <Grid items={INTERNATIONAL} testid="international-grid" />
        </div>
      </section>
    </div>
  );
}
